import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'titulo',
  templateUrl: 'titulo.html',
  styleUrls: ['titulo.scss'],
  standalone: true,
  imports: [
    CommonModule,
  ]
})
export class TituloComponent {

  @Input()
  config: any;
  constructor(public platform: Platform) { };

  ngOnInit() {
  }

  getFontColor() {
    return this.config.font_color;
  }

  getFontSize() {
    return this.platform.width() >= 768 ? (this.config.font_size * 2) + 'px' : this.config.font_size + 'px';
  }
}
